import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function VaccinatedRow(props) {
  // console.log('props ', props);
  const { name, firstDosePerc, secondDosePerc, thirdDosePerc } = props;
  const railTarget = useRef();
  const stageWidth = useSelector((state) => state.browserUtils.width);
  const [railWdith, setRailWdith] = useState(0);

  useEffect(() => {
    const divElement = railTarget.current;
    setRailWdith(divElement.offsetWidth);
  }, [stageWidth]);

  const styleFirst = {
    left: `${firstDosePerc}%`,
  };
  const styleSecond = {
    left: `${secondDosePerc}%`,
  };
  const styleThird = {
    left: `${thirdDosePerc}%`,
  };

  // if dots are too close to each other, move them apart
  // const pos1Text = (railWdith / 100) * firstDosePerc - 34;
  // const pos2Text = (railWdith / 100) * secondDosePerc - 34;
  // const difference = pos1Text - pos2Text;
  // const posAdjust1 = difference < 30 ? 10 : 0;
  // const posAdjust2 = difference < 30 ? 30 : 10;

  const styleFirstText = {
    left: `${(railWdith / 100) * firstDosePerc - 34}px`,
  };

  const styleSecondText = {
    left: `${(railWdith / 100) * secondDosePerc - 34}px`,
  };

  const styleThirdText = {
    left: `${(railWdith / 100) * thirdDosePerc - 104}px`,
  };

  /* const innerBarWidth =
    (railWdith / 100) * (firstDosePerc - secondDosePerc) + 10;
   const styleBetweenDots = {
    left: `${secondDosePerc}%`,
    width: `${innerBarWidth}px`,
  }; */

  return (
    <div className="row-section">
      <div className="location">{name}</div>
      <div className="dot-plot-wrap">
        <div className="dot-plot-rail" ref={railTarget}>
          {/* <div className="bewtween-dots-bg" style={styleBetweenDots} /> */}
          <div className="first-dose-dot" style={styleFirst} />
          <div className="second-dose-dot" style={styleSecond} />
          <div className="third-dose-dot" style={styleThird} />
          <div className="first-dose-text" style={styleFirstText}>
            {firstDosePerc}%
          </div>
          <div className="second-dose-text" style={styleSecondText}>
            {secondDosePerc}%
          </div>
          <div className="third-dose-text" style={styleThirdText}>
            {thirdDosePerc}%
          </div>
        </div>
      </div>
    </div>
  );
}
